














































































































































































































































import Vue, { PropOptions } from 'vue';
import { botPathRules, handlerConfigRules, toStateRules } from '@/rules/bots.rules';
import { OmniChatSchema } from '@omnichat/omnichat-model';
import BotsService from '@/services/BotService';
import ChipFeatureFlag from '@/components/ChipFeatureFlag.vue';

export default Vue.extend({
  components: { ChipFeatureFlag },
  props: {
    botPath: {
      type: Object,
    } as PropOptions<OmniChatSchema.BotState>,
    showDialog: {
      type: Boolean,
      default: false,
    },
    pastPath: {
      type: Object,
    } as PropOptions<OmniChatSchema.BotState>,
    pathType: {
      type: String,
    } as PropOptions<OmniChatSchema.BotHandlerType>,
  },
  data() {
    return {
      newBotPath: (this as any).initializeBotPathItem(this.botPath),
      path: {
        type: Object,
      },
      botPathRules: botPathRules.attr,
      handlerConfigRules: handlerConfigRules.attr,
      toStateRules: toStateRules.attr,
      valid: true,
      routingText: true,
      teams: this.$store.state.team && this.$store.state.team.teams,
      users: this.$store.state.user && this.$store.state.user.users,
      actions: [
        { title: 'Próximo caminho', value: 'BOT_STATE_CHANGE_HANDLER', icon: 'mdiRoutes' },
        { title: 'Redirecionar para um time', value: 'SEND_TO_TEAM', icon: 'mdiAccountGroup' },
        { title: 'Redirecionar para um usuário', value: 'SEND_TO_USER', icon: 'mdiAccount' },
        (this as any).hasAPIIntent() && { title: 'Chamar API', value: 'REMOTE_API_HANDLER', icon: 'mdiPowerPlug' },
        { title: 'Encerrar atendimento', value: 'CLOSE_INTERACTION_HANDLER', icon: 'mdiCheck' },
      ].filter(Boolean),
      channelActions: [
        { title: 'Redirecionar para um canal', value: 'SEND_TO_CHANNEL', icon: 'mdiChatProcessingOutline' },
      ],
      channels: [
        { title: 'Whatsapp', value: 'WAB', icon: 'mdiWhatsapp' },
        { title: 'WebChat', value: 'WEBCHAT', icon: 'mdiChat' },
        { title: 'Facebook Messenger', value: 'FBMESSENGER', icon: 'mdiFacebookMessenger' },
      ],
      channelModel: 'SEND_TO_CHANNEL',
    };
  },
  async mounted() {
    const botFeatures = await BotsService.loadBotFeatures();

    this.actions = [
      ...botFeatures,
      ...this.actions,
    ];

    if (this.pathType === OmniChatSchema.BotHandlerType.channelStateChangeHandler) {
      this.newBotPath.handlerType = OmniChatSchema.BotHandlerType.sendToChannel;

      this.onChageHandlerType();
    }
  },
  methods: {
    hasAPIIntent() {
      const initialState = this.$store.state.bot.bot.configuration.initialState;
      const intentTypes = new Set();

      const iterateNextStates = (states) => {
        states.forEach(state => {
          intentTypes.add(state.handlerType);

          if (state.toState && state.toState.to) {
            iterateNextStates(state.toState.to);
          }
        });
      }

      if (initialState) {
        iterateNextStates([initialState]);
      }

      return intentTypes.has(OmniChatSchema.BotHandlerType.remoteApiHandler);
    },
    initializeBotPathItem(botPath: OmniChatSchema.BotState) {
      if (botPath) {
        return botPath;
      }
      return {
        title: '',
        index: '',
        handlerType: '',
      };
    },
    onChageHandlerType() {
      if (this.newBotPath) {
        this.newBotPath[`handlerConfig`] && delete this.newBotPath[`handlerConfig`];
        this.newBotPath[`toState`] && delete this.newBotPath[`toState`];
      }
      switch (this.newBotPath.handlerType) {
        case OmniChatSchema.BotHandlerType.channelStateChangeHandler:
        case OmniChatSchema.BotHandlerType.botStateChangeHandler:
          this.newBotPath.toState = {
            title: '',
            to: [],
          } as OmniChatSchema.ToBotState;

          break;

        case OmniChatSchema.BotHandlerType.sendToTeam:
          this.newBotPath.handlerConfig = {
            teamId: '',
            routingMessage: '',
          } as OmniChatSchema.SendToTeamHandlerConfig;

          break;

        case OmniChatSchema.BotHandlerType.sendToUser:
          this.newBotPath.handlerConfig = {
            userId: '',
            routingMessage: '',
          } as OmniChatSchema.SendToUserHandlerConfig;

          break;

        case OmniChatSchema.BotHandlerType.remoteApiHandler:
          this.newBotPath.handlerConfig = {
            handlerId: '',
            url: 'https://',
            fallbackTeam: '',
          } as OmniChatSchema.RemoteAPIHandlerConfig;

          break;

        case OmniChatSchema.BotHandlerType.closeInteractionHandler:
          this.newBotPath.handlerConfig = {
            closingMessage: '',
          } as OmniChatSchema.CloseInteractionHandlerConfig;

        case OmniChatSchema.BotHandlerType.sendToChannel:
          this.newBotPath.handlerConfig = {
            channel: '' as any,
          } as OmniChatSchema.SendToChannelHandlerConfig;
          this.newBotPath.toState = {
            title: '',
            to: [],
          } as OmniChatSchema.ToBotState;

          break;

        default:
          break;
      }
    },
    filteredchannels() {
      let channels = [];
      const actualItens: any[] = [];
      for (const item of this.pastPath.toState.to as any) {
        actualItens.push(item.handlerConfig.channel);
      }

      channels = this.channels.filter((channel) =>
        actualItens.indexOf(channel.value) === -1,
      );

      return channels;
    },
    onCancel() {
      this.$emit('close');
    },
    onSave() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.botPath) {
          this.$emit('update');
        } else {
          this.$emit('save', this.newBotPath);
        }
      }
    },
  },
  computed: {
    show: {
      get(): boolean {
        return this.showDialog;
      },
      set(showDialog: boolean) {
        if (!showDialog) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    '$store.state.team.teams'(val) {
      this.teams = val;
    },
    '$store.state.user.users'(val) {
      this.users = val;
    },
    'botPath'(val) {
      this.newBotPath = (this as any).initializeBotPathItem(this.botPath);
    },
  },
});
